// extracted by mini-css-extract-plugin
export default {"inputRequest":"input-request-module-inputRequest--D_zB_","telephoneLink":"input-request-module-telephoneLink--Ox4ch","secondText":"input-request-module-secondText--fwzjL"};